<template>
    <div>
        <div v-if="query" class="position-relative bg-light p-3 border rounded">
            <span class="float-right close-icon" @click="close" v-if="!isMobile">
                <font-awesome-icon icon="times-circle"/>
            </span>
            <div class="container">
                <h4>Anfrage zu "{{query.obj_name}}"</h4>
                <div class="my-2">
                    <strong>Anfragedetails</strong>
                </div>
                <table class="table table-sm table-borderless">
                    <tr>
                        <th>Datum</th>
                        <td>{{query.datum}}</td>
                    </tr>
                    <tr v-if="query.company != ''">
                        <th>Firma</th>
                        <td>{{query.company}}</td>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{{query.name}}</td>
                    </tr>
                    <tr>
                        <th>E-Mail</th>
                        <td><a :href="'mailto:' + query.email" class="text-dark" style="text-decoration: underline">{{query.email}}</a></td>
                    </tr>
                    <tr>
                        <th>Telefon</th>
                        <td><a :href="'tel:' + query.phone" class="text-dark" style="text-decoration: underline">{{query.phone}}</a></td>
                    </tr>
                    <tr>
                        <th>PLZ / Ort</th>
                        <td>{{query.plzort}}</td>
                    </tr>
                    <tr>
                        <th>Zeitraum</th>
                        <td>{{query.date_from}} bis {{query.date_to}}</td>
                    </tr>
                </table>
                <div>
                    <h5>Anfrage</h5>
                    <p>{{query.text}} </p>
                </div>
                <button class="btn btn-secondary btn-sm" @click="showCommentForm">
                    {{$t('intern_objekte_anfragen_details.neuer_kommentar')}}
                </button>
                <div class="form-group mt-4 d-none" ref="form">
                    <textarea
                        class="form-control"
                        v-model="comment"
                        :class="{ 'is-invalid': $v.comment.$error }"
                        placeholder="Schreiben Sie Ihren Kommentar"
                    ></textarea>
                    <div class="invalid-feedback" v-if="!$v.comment.required">Bitte Kommentar eingeben</div>
                    <button class="btn btn-success mt-2" @click="newComment">
                        Speichern
                    </button>
                </div>
                <div class="mt-3" v-if="comments.length > 0">
                    <h5>Kommentare</h5>
                    <query-comment-component
                        v-for="comment in comments"
                        :key="comment.id"
                        :comment="comment"
                        @delete="comments = comments.filter(c => c.id != comment.id)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QueryCommentComponent from './QueryComment';
    import EventBus              from '../../EventBus';
    import { IsMobileMixin }     from '../../mixins/IsMobile';
    import { required }          from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                query: null,
                comment: '',
                comments: []
            }
        },
        mixins: [IsMobileMixin],
        components: {
            QueryCommentComponent
        },
        methods: {
            close() {
                this.query = null;
                EventBus.$emit('ACTIVE_QUERY_TO_NULL', null);
            },
            read(query) {
                this.query = query;
                if(query && typeof query === 'object') {
                    this.fetchComments();

                    if(query && typeof query === 'object' && query.status == 'unread') {
                        this.$store.state.loading = true;
                        this.$http.put('queryApi/readQuery?id=' + this.query.id).then(response => {
                            if(response.data == 'success'){
                                this.$store.dispatch('NOTIFICATIONS_COUNT');
                            }
                        }).catch( error => {
                            console.log(error);
                        }).then(() => {
                            this.$store.state.loading = false;
                        });
                    }
                }
            },
            showCommentForm() {
                let form = this.$refs.form;

                if(form.classList.contains('d-none')){
                    form.classList.remove('d-none');
                }else {
                    form.classList.add('d-none');
                }
            },
            newComment() {
                this.$v.$touch();
                if(!this.$v.$invalid){
                    let data = {
                        id: this.query.id,
                        comment: this.comment
                    };

                    this.$store.state.loading = true;
                    this.$http.post('/queryApi/createQueryComment', data).then( response => {
                        this.comment = '';
                        this.$nextTick(() => { this.$v.$reset() })
                        this.$bvToast.toast(response.data, {
                            title: 'Benachrichtigung',
                            variant: 'success'
                        });
                    }).catch( error => {
                        this.$bvToast.toast(error.response.data.data, {
                            title: 'Fehlermeldung',
                            variant: 'danger'
                        });
                    }).then(() => {
                        this.$store.state.loading = false;
                        this.fetchComments();
                    });
                }
            },
            fetchComments() {
                this.$store.state.loading = true;
                this.$http.get('/queryApi/getQueryComment/?query_id=' + this.query.id).then( response => {
                    this.comments = JSON.parse(response.data);
                }).catch( error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                })
            }
        },
        created() {
            EventBus.$on('READ_QUERY', this.read);
        },
        beforeDestroy() {
            EventBus.$off('READ_QUERY', this.read);
        },
        validations: {
            comment: { required }
        }
    }
</script>

<style scoped>
textarea{
    resize: none;
    width: 100%;
    height: 200px;
}
</style>
